import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppStore } from '../../../state/app.repository';
import { ConferencePanel } from '../conference-panel/conference-panel/conference-panel';
import { RoomLogin, PreparationArea } from '../../../features/pre-join';
import { OdinConnectionStatus, OdinService } from '../../services/odin.service';
import { UserLogin } from '../../../features/user-login';
import { ShowPromo } from '../show-promo/show-promo';
import { GeneralSettings } from '../../../features/settings';
import { RecoverPassword } from '../../../features/recover-password';
import { About } from '../../../features/about';

@Component({
  selector: 'andor-view-outlet',
  standalone: true,
  imports: [
    CommonModule,
    ConferencePanel,
    RoomLogin,
    UserLogin,
    ShowPromo,
    GeneralSettings,
    PreparationArea,
    RecoverPassword,
    About,
  ],
  templateUrl: './view-outlet.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './view-outlet.scss',
})
export class ViewOutlet {
  protected readonly OdinConnectionStatus = OdinConnectionStatus;
  constructor(
    public appStore: AppStore,
    public odin: OdinService
  ) {}
}
